module.exports = __webpack_public_path__ + "img/logo-hearts.a82c92cd.png";